import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Collapse, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import informationOutline from "@iconify/icons-mdi/information-outline";
import { Icon } from "@iconify/react";
import {
  MyLeaveEffectiveWorkDaysHeader,
  MyLeaveEffectiveWorkDaysTable,
} from "my-leave/components";
import { useOcClientState } from "oc/hooks";

interface MyLeaveEffectiveWorkDaysBlockProps {
  effectiveWorkDaysByDays: any[]; // Replace 'any[]' with the actual type if known
  currentYearEffectiveWorkDays: number; // Replace 'number' with the actual type if different
}

export const MyLeaveEffectiveWorkDaysBlock: React.FC<
  MyLeaveEffectiveWorkDaysBlockProps
> = ({ effectiveWorkDaysByDays, currentYearEffectiveWorkDays }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [expanded, setExpanded] = useOcClientState<boolean>(
    `collapseExpanded`,
    false,
  );

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Box>
      <MyLeaveEffectiveWorkDaysHeader
        handleExpandClick={handleExpandClick}
        expanded={expanded}
        currentYearEffectiveWorkDays={currentYearEffectiveWorkDays}
      />
      <Collapse in={expanded} timeout="auto">
        <Box
          padding="0px 16px 16px 16px"
          style={{
            backgroundColor: theme.palette.gray30.main,
          }}
        >
          <Box
            style={{
              border: `1px solid ${theme.palette.gray40.main}`,
              borderRadius: 8,
              padding: 4,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Icon
              icon={informationOutline}
              width="20px"
              color={theme.palette.gray60.main}
            />
            <Box width="10px" />
            <Box width="349px">
              <Typography
                variant="caption"
                style={{ color: theme.palette.gray60.main }}
              >
                {t("MY_LEAVE_EFFECTIVE_WORK_DAY_INFO")}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box width="10px" />
        <MyLeaveEffectiveWorkDaysTable
          effectiveWorkDaysByDays={effectiveWorkDaysByDays}
        />
      </Collapse>
    </Box>
  );
};

export default MyLeaveEffectiveWorkDaysBlock;
